import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getContentPostsRequest, getContentPostsRequestError, getContentPostsRequestSuccess } from "../../slices/content-management/PostsSlice";

export const GetContentPostsAPI = (page, limit, keyword, registeredDate, status) => async (dispatch) => {

    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        keyword: keyword,
        registeredDate: registeredDate,
        status: status
    }).toString();

    const urlWithParams = `${endpoints.contentPosts}?${queryParams}`;
    try {
        dispatch(getContentPostsRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getContentPostsRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getContentPostsRequestError(_error));
            });
    } catch (error) { }
};
